import { Link } from 'react-router-dom';
import { Info, FileText, Shield, Scale, Mail } from 'lucide-react';

export default function AboutSection() {
  return (
    <div className="space-y-6">
      {/* App Info */}
      <div className="bg-white dark:bg-dark-bg border border-gray-200 dark:border-dark-border rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <Info className="w-5 h-5" />
          About SureDox
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          SureDox is a document redaction platform that uses AI to automatically detect and redact
          Personally Identifiable Information (PII) from your PDF documents. Protect sensitive data
          quickly and accurately with our automated processing pipeline.
        </p>
      </div>

      {/* Legal Links */}
      <div className="bg-white dark:bg-dark-bg border border-gray-200 dark:border-dark-border rounded-lg p-6">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Legal</h3>
        <div className="space-y-2">
          <LegalLink
            to="/terms"
            icon={FileText}
            label="Terms of Service"
          />
          <LegalLink
            to="/privacy"
            icon={Shield}
            label="Privacy Policy"
          />
          <LegalLink
            to="/paia"
            icon={Scale}
            label="PAIA Manual"
          />
        </div>
      </div>

      {/* Support */}
      <div className="bg-white dark:bg-dark-bg border border-gray-200 dark:border-dark-border rounded-lg p-6">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Support</h3>
        <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
          <Mail className="w-4 h-4 text-gray-400 dark:text-gray-500" />
          <a
            href="mailto:support@suredox.co.za"
            className="text-emerald-600 dark:text-emerald-400 hover:underline"
          >
            support@suredox.co.za
          </a>
        </div>
      </div>
    </div>
  );
}

function LegalLink({ to, icon: Icon, label }) {
  return (
    <Link
      to={to}
      className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-800 transition"
    >
      <Icon className="w-4 h-4 text-gray-400 dark:text-gray-500" />
      {label}
    </Link>
  );
}
